import { FormComponent } from '@ubud/form';
import { Component, Input, OnInit } from '@angular/core';
import { RegisterInstitutionGovernment } from '@lemsar/auth/domains/models/register';
import { Ministry } from '@lemsar/common/domains/models/ministry';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    14/06/2018
 */
@Component({
    selector: 'lemsar-register-institution-government-form',
    templateUrl: './register-institution-government.form.html',
})
export class RegisterInstitutionGovernmentForm extends FormComponent<RegisterInstitutionGovernment> implements OnInit {
    @Input()
    public set ministries(val: Array<Ministry>) {
        if (val) {
            this._ministries = val;
            this.ministries$ = val;
        }
    }

    public _ministries: Array<Ministry> = [];
    public ministries$: Array<Ministry> = [];

    public dataType: { id: number; name: string }[];
    public dataEchelon: { id: number; name: string }[];

    public ngOnInit(): void {
        this.dataType = [{ id: 10, name: 'Pemerintah Pusat' }, { id: 20, name: 'Pemerintah Daerah' }];
        this.dataEchelon = [{ id: 1, name: '1' }, { id: 2, name: '2' }, { id: 3, name: '3' }, { id: 4, name: '4' }];
    }

    public handleFilter(value: any): void {
        this.ministries$ = this._ministries.filter((s: any) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public onChange(type: any, file: any): void {
        // TODO: fix this
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/views/components/register-institution-government.form.ts